import { useUpdateEffect } from '@cian/react-utils';

import { type FC } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';

import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

export const MapSizeUpdateManager: FC = () => {
  const viewMode = useListingLayoutViewModeSelector();
  const { map } = useMapStoreContext();

  useUpdateEffect(() => {
    if (viewMode !== 'list') {
      map.container.fitToViewport();
    }
  }, [viewMode]);

  return null;
};
